/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CampoExtraBooleanDirectiva.$inject = [];
export default function CampoExtraBooleanDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@',
            'asignarFalseDefecto': '@'
        },
        template: require('./campos-extra-boolean.html'),
        controller: 'CamposExtraBooleanCtrl as campExtBol',
        bindToController: true
    }
}